import template from './clusters-button.template.html';
import controller from './clusters-button.controller';

const clustersButtonComponent = {
  template,
  controller,
  controllerAs: 'clustersButtonCtrl'
};

export default clustersButtonComponent;



// WEBPACK FOOTER //
// ./ui/src/components/clusters-button/clusters-button.component.js